import flowIdManagment from "core/Utils/FlowIdManagment";
import { setFlowIdAndUTMSourceHeaders } from "./headers";

export default function interceptor(){
    
    const flowManagement = flowIdManagment();
    const _setFlowIdOnResponse = (response) => {
        const flowId = response?.headers["x-cred-flow-id"];
        if (flowId) {
          flowManagement.addToSessionStorage(flowId);
        }
    };

    function onRequest(config) {
        flowManagement.manageFlowIdLifeSpan();
        return setFlowIdAndUTMSourceHeaders(config);
    }
    
    const onResponseError = (error, a, b) => {
        const defaultError = {
          data: {
            code: error.code || "GENERAL_ERROR",
            message: error.message || "error",
          },
        };
        _setFlowIdOnResponse(error?.response)
        if (error.response) {
          return new Promise((resolve, reject) => reject(error.response));
        } else {
          return new Promise((resolve, reject) => reject(defaultError));
        }
    };
    
    const onResponseSuccess = (response = {}, request) => {
        _setFlowIdOnResponse(response);
        return new Promise((resolve) =>
          setTimeout(function () {
            resolve(response);
          }, 500)
        );
    };

    return {
        onResponseError,
        onResponseSuccess, 
        onRequest
    }
}

